module.exports = __webpack_public_path__ + "img/luxury-1.eae812bd.png";